import { render, staticRenderFns } from "./PotentialWorker.vue?vue&type=template&id=0be1f2eb&scoped=true&"
import script from "./PotentialWorker.vue?vue&type=script&lang=js&"
export * from "./PotentialWorker.vue?vue&type=script&lang=js&"
import style0 from "./PotentialWorker.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PotentialWorker.vue?vue&type=style&index=1&id=0be1f2eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be1f2eb",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ExperiencesTable: require('/workspace/components/Experiences/ExperiencesTable.vue').default})
